import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { GET_PROPERTY_VIEWS } from '@general/graphql/properties.graph';
import { uniqueListOfPropertyViews } from '@general/helpers/property.helpers';

const usePropertyViews = id => {
    const [propertyViews, setPropertyViews] = useState();
    const [uniquePropertyViews, setUniquePropertyViews] = useState();
    const { data, ...rest } = useQuery(GET_PROPERTY_VIEWS, { variables: { id } });

    useEffect(() => {
        if (!data) {
            return;
        }

        setPropertyViews(data.propertyViews);
    }, [data]);

    useEffect(() => {
        if (!propertyViews) {
            return;
        }

        const uniquePropertyList = uniqueListOfPropertyViews(propertyViews);
        setUniquePropertyViews(uniquePropertyList);
    }, [propertyViews]);

    return {
        data: propertyViews,
        uniqueViews: uniquePropertyViews,
        ...rest,
    };
};

export default usePropertyViews;
